import {useState} from "react";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {WidgetEntity} from "@/lib/queries/statuspages.ts";
import {WidgetTheme} from "@/pages/tools/theme.js.ts";
import {UptimeWidgetForm} from "@/pages/tools/UptimeWidgetForm.tsx";
import {UptimeWidgetPreview} from "@/pages/tools/UptimeWidgetPreview.tsx";

interface WidgetState {
  theme: WidgetTheme;
  value?: WidgetEntity;
  link: string;
}

export const UptimeWidgetContent = () => {
  const {brand} = useCurrentUserContext();
  const [state, setState] = useState<WidgetState>({
    theme: WidgetTheme.Light,
    link: "",
  });
  return (
    <div className="row">
      <UptimeWidgetForm
        className="col-md-6"
        theme={state.theme}
        brand={brand}
        onSetTheme={(theme) =>
          setState({
            ...state,
            theme,
          })
        }
        value={state.value}
        onSelected={(value) =>
          setState({
            ...state,
            value,
          })
        }
        onLinkSelected={(link) =>
          setState({
            ...state,
            link,
          })
        }
      />
      {state.value && (
        <UptimeWidgetPreview className="col-md-6" link={state.link} value={state.value} theme={state.theme} />
      )}
    </div>
  );
};
